"use client";
import React, { useEffect, useRef, useState } from "react";
import { Box, Typography } from "@mui/material";

import HeroBanner from "./HeroBanner";

import SearchLayout from "../common/SearchLayout";
import { PaymentIconsHeaderMobile } from "../common/PaymentHeader";

// import { Swiper, SwiperSlide } from "swiper/react";
// import { Pagination, Navigation } from "swiper/modules";

// import "swiper/css";
// import "swiper/css/effect-fade";
// import "swiper/css/pagination";
// import "swiper/css/navigation";

// import { Swiper, SwiperSlide } from "swiper/react";
// Import Swiper styles
// import "./styles.css";
// import required modules
// import { Pagination } from "swiper/modules";

// import ShipIcon from "@mui/icons-material/DirectionsBoatFilledRounded";
// import PaymentIcon from "@mui/icons-material/PaymentRounded";
// import LockIcon from "@mui/icons-material/LockRounded";
// import PeopleIcon from "@mui/icons-material/PeopleAltRounded";
// import SecurityIcon from "@mui/icons-material/SecurityRounded";

// import dynamic from "next/dynamic";
// const HeroBanner = dynamic(() => import("../../components/demo/HomeHeroWithBanner"), {
//   ssr: false,
// });

const HomeHeroWithBanner = () => {
  const [isVideoReady, setIsVideoReady] = useState(false);
  const videoRef = useRef<HTMLVideoElement>(null);

  useEffect(() => {
    if (videoRef.current && videoRef.current.readyState >= 2) {
      setIsVideoReady(true);
    }
  }, []);

  return (
    <Box>
      <Box sx={{ position: "relative" }}>
        <Box
          sx={{
            bgcolor: "#000C37",
            width: "100%",
            position: "relative",
            p: { xs: "0rem", sm: "calc(1.5rem - 3px)", xl: "2rem" },
          }}
        >
          <Box
            sx={{
              position: "relative",
              borderRadius: { xs: "0px", sm: "20px" },
              border: { xs: "none", sm: "3px solid #fff" },
              boxShadow: "0px 0px 15px rgba(0,0,0,0.1)",
              overflow: "hidden",
              minHeight: { xs: "200px", sm: "270px", md: "365px" },
            }}
          >
            <Box
              component="video"
              ref={videoRef}
              autoPlay
              loop
              muted
              playsInline
              preload="auto"
              poster="./images/hero/wcv-hero-poster.webp"
              aria-hidden="true"
              onLoadedData={() => setIsVideoReady(true)}
              // MUI's polymorphic Box(component="video") prop-type resolution doesn't know
              // fetchPriority, and typing it directly breaks the whole element's overload
              // resolution (see docs/performance/FIXES.md Fix 6). Spread it in pre-typed as
              // `any` so it never enters that overload check, since this is the page's LCP
              // element and Lighthouse's lcp-request-discovery audit specifically asks for it.
              {...({ fetchPriority: "high" } as Record<string, string>)}
              sx={{
                position: "relative",
                pointerEvents: "none",
                width: "100%",
                height: "100%",
                minHeight: { xs: "200px", sm: "270px", md: "365px" },
                maxHeight: { xs: "60vh", md: "50vh" },
                objectFit: "cover",
                zIndex: 2,
                display: "flex",
              }}
            >
              <source src="./videos/wcv-hero.webm" type="video/webm" />
              <source src="./videos/wcv-hero.mp4" type="video/mp4" />
            </Box>

            {/* Poster image overlay: this is the actual LCP element (tiny, immediately paintable),
                shown until the video reports it can render its own first frame. Absolutely positioned
                so it never affects this container's layout/height, which is driven by the video above. */}
            <Box
              component="img"
              src="./images/hero/wcv-hero-poster.webp"
              alt=""
              sx={{
                position: "absolute",
                inset: 0,
                width: "100%",
                height: "100%",
                objectFit: "cover",
                zIndex: 2,
                pointerEvents: "none",
                opacity: isVideoReady ? 0 : 1,
                transition: "opacity 0.15s linear",
              }}
            />

            <Box
              sx={{
                background: {
                  xs: "linear-gradient(0deg, rgba(50,0,170,0.4) 24%, rgba(0,0,0,0) 50%)",
                  sm: "linear-gradient(0deg, rgba(0,0,0,0) 0%, rgba(0,0,0,0.30) 60%, rgba(0,0,0,0.50) 100%)",
                },
                width: "100%",
                height: "100%",
                position: "absolute",
                inset: "0px",
                zIndex: 3,
              }}
            ></Box>
          </Box>

          <Typography
            variant="h1"
            sx={{
              position: "absolute",
              top: { xs: "unset", sm: "4.5rem", xl: "5rem" },
              bottom: { xs: "1.8rem", sm: "unset" },
              left: "50%",
              transform: "translateX(-50%)",
              zIndex: 4,
              width: "100%",
              color: "#fff",
              fontSize: { xs: "1.4rem", sm: "2rem", md: "3rem" },
              fontWeight: 600,
              fontFamily: "'blauerNue', 'blauerNue Fallback'",
              textAlign: "center",
              textShadow: "0px 1px 8px rgba(0,0,0,0.5)",
            }}
          >
            {/* <Box>Your Next Great Escape Begins Here</Box>
            <Box>Let’s Cruise!</Box> */}
            <Box>Experience the Luxury of Cruise Holidays!</Box>
          </Typography>

          <Box
            sx={{
              bgcolor: "#EDF1FF",
              width: "100%",
              height: { xs: "calc(100% - 14rem)", lg: "calc(100% - 8rem)" },
              position: "absolute",
              left: "0rem",
              top: "0rem",
              zIndex: 1,
            }}
          ></Box>
        </Box>

        <Box
          sx={{
            bgcolor: { xs: "unset", sm: "#000C37", lg: "unset" },
            position: { xs: "relative", lg: "absolute" },
            zIndex: 5,
            bottom: { xs: "0rem", lg: "5rem" },
            left: "0px",
            right: "0px",
            width: "100%",
          }}
        >
          <SearchLayout />
        </Box>
      </Box>

      <PaymentIconsHeaderMobile sx={{ mt: "6px" }} />

      <HeroBanner />
    </Box>
  );
};

export default HomeHeroWithBanner;
